import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    leftGridTypographies: {
        width: "300px",
        display: "inline-block",
        color: '#333',
    },

    parentGridContainer: {
        borderRadius: 4,
        width: '800px',
        maxWidth: '100%',
        fontFamily: 'Noto Sans JP',
        height: "580px"
    },
    gridContainer: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },

    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2),
        background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
        border: '2px solid white',
        boxShadow: 'none',
    },
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
        },
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(3),
        // marginRight: "150px",
    },
   
    buttonsGrid: {
        margin: "20px auto"
    },
    height100: {
        height: '100px',
    },


}));